import moment from "moment";
import { mapState, mapMutations } from "vuex";

import Input from "../../components/UI/CustomInputs/Input.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import InputMoney from "../../components/UI/CustomInputs/InputMoney.vue";
import ModalConductor from "../../components/Modals/ModalCreateConductor.vue";
import ModalVehicle from "../../components/Modals/ModalCreateVehicle.vue";
import InputInfinit from "../../components/UI/CustomInputs/InputInfinit.vue";
import ModalCreateProducts from "../../components/Modals/ModalCreateProduct.vue";

import { mascaraMoeda } from "../../utils/maskMoney";
import { ValidadeMdfe } from "../../validators/mdfe";
import { ufs } from "../../common/index";

import ServiceMdfe from "../../services/serviceMdfe";
import ServiceVehicle from "../../services/serviceVehicle";
import ServiceConductor from "../../services/serviceConductor";
import ServiceSettings from "../../services/serviceSettings";
import ServiceProducts from "../../services/serviceProducts";
import { handleErrorsMdfe } from "../../utils/handleErrorsMdfe";

const mixinMdfe = {
  components: {
    Input,
    InputSelect,
    InputMoney,
    ModalConductor,
    ModalVehicle,
    InputInfinit,
    ModalCreateProducts,
  },
  data() {
    return {
      cep_carregamento: "",
      cep_descarregamento: "",
      isInvalidInput: "",
      carregamento:
      {
        codigo_municipio: "",
        nome_municipio: "",
      },
      descarregamento:
      {
        codigo_municipio: "",
        nome_municipio: "",
        documentos_fiscais: []
      },
      ciotAtual: {
        codigo_ciot: "",
        cpf_responsavel: "",
      },
      valePedagioAtual: {
        cnpj_fornecedor: "",
        cpf_responsavel: "",
        comprovante: "",
        valor: 0,
        tipo: "1",
      },
      componenteAtual: {
        tipo_componente: "99",
        valor_componente: 0,
        descricao_componente: "",
      },
      parcelaAtual: {
        data_vencimento_parcela: null,
        valor_parcela: 0
      },
      veiculoReboque: {
        placa: "",
        renavam: "",
        tara: 0,
        capacidade_kg: 0,
        uf_licenciamento: "",
        tipo_carroceria: "",
        proprietario: {
          cpf: "",
          cnpj: "",
          nome: "",
          razao_social: "0",
          ie: "",
          rntrc: "00000000",
          tipo_proprietario: "0",
          uf: "",
        }
      },
      contratanteUN: {
        cpf: "",
        cnpj: "",
        tipo: "0",
      },
      pagamentoFrete: {
        nome: "",
        cpf: "",
        valor_contrato: 0,
        forma_pagamento: "0",
        valor_adiantamento: 0,
        componentes_pagamento_frete: [],
        informacoes_bancarias: {
          tipo_informacao_bancaria: "0",
          numero_banco: "",
          numero_agencia: "",
          pix: ""
        },
        informacoes_pagamento_prazo: [],
      },
      chaves: "",
      ambiente: [
        { value: 1, text: "Produção" },
        { value: 2, text: "Homologação" },
      ],
      tipoDocumento: [
        { value: 1, text: "Pessoa Física" },
        { value: 2, text: "Pessoa Jurídica" },
      ],
      carrocerias: [
        { value: "00", text: "Não aplicável" },
        { value: "01", text: "Aberta" },
        { value: "02", text: "Fechada/Baú" },
        { value: "03", text: "Granelera" },
        { value: "04", text: "Porta Container" },
        { value: "05", text: "Sider" },
      ],
      selectDocument: 1,
      selectContractant: 1,
      emitente: [
        { value: 1, text: "Prestador de serviço de transporte." },
        { value: 2, text: "Transportador de Carga Própria." },
        { value: 3, text: "Prestador de serviço de transporte que emitirá CT-e Globalizado." },
      ],
      transportador: [
        { value: 1, text: "ETC - Empresa de Transporte de Cargas." },
        { value: 2, text: "TAC - Transportador Autônomo de Cargas." },
        { value: 3, text: "CTC - Cooperativa de Transporte de Cargas." },
      ],
      tipoCarga: [
        { value: "01", text: "01-Granel sólido" },
        { value: "02", text: "02-Granel líquido" },
        { value: "03", text: "03-Frigorificada" },
        { value: "04", text: "04-Conteinerizada" },
        { value: "05", text: "05-Carga Geral" },
        { value: "06", text: "06-Neogranel" },
        { value: "07", text: "07-Perigosa (granel sólido)" },
        { value: "08", text: "08-Perigosa (granel líquido)" },
        { value: "09", text: "09-Perigosa (carga frigorificada)" },
        { value: "10", text: "10-Perigosa (conteinerizada)" },
        { value: "11", text: "11-Perigosa (carga geral)" },
        { value: "12", text: "12-Perigosa (granel Pressurizada)" },

      ],
      tipo_proprietario: [
        { value: "0", text: "TAC – Agregado" },
        { value: "1", text: "TAC Independente" },
        { value: "2", text: "Outros" },
      ],
      tipo_informacao_bancaria: [
        { value: "0", text: "Selecione ..." },
        { value: "1", text: "1 - Banco e agência" },
        { value: "2", text: "2 - CNPJ da Instituição de Pagamento Eletrônico do Frete" },
        { value: "3", text: "3 - Chave PIX para recebimento do frete" },
      ],
      unidade: [
        { value: "01", text: "KG" },
        { value: "02", text: "TON" },
      ],
      pagamento: [
        { value: 0, text: "Pagamento à vista" },
        { value: 1, text: "Pagamento à prazo" },
      ],
      tipocomponente: [
        { value: "01", text: "Vale Pedágio" },
        { value: "02", text: "Impostos, taxas e contribuições" },
        { value: "03", text: "Despesas (bancárias, meios de pagamento, outras)" },
        { value: "04", text: "Frete" },
        { value: "99", text: "Outros" },
      ],
      combinacao: [
        { value: "", text: "Selecione..." },
        { value: "02", text: "Veículo Comercial 2 eixos" },
        { value: "04", text: "Veículo Comercial 3 eixos" },
        { value: "06", text: "Veículo Comercial 4 eixos" },
        { value: "07", text: "Veículo Comercial 5 eixos" },
        { value: "08", text: "Veículo Comercial 6 eixos" },
        { value: "10", text: "Veículo Comercial 7 eixos" },
        { value: "11", text: "Veículo Comercial 8 eixos" },
        { value: "12", text: "Veículo Comercial 9 eixos" },
        { value: "13", text: "Veículo Comercial 10 eixos" },
        { value: "14", text: "Veículo Comercial Acima de 10 eixos" },
      ],
      conductor: [],
      vehicle: [],
      dadosMdfe: {
        id: "",
        data_mdfe: moment().format('YYYY-MM-DD HH:mm'),
        ambiente: "",
        emitente: 2,
        tipoCarga: '',
        url_notificacao: "",
        response: "",
        status: "",
        unidade: "01",
        modalidade: 1,
        uf_carregamento: "",
        uf_descarregamento: "",
        valor_carga: 0,
        peso_bruto: 0,
        carregamento: [],
        descarregamento: [],
        informacoes_complementares: '',
        rodoviario: {
          rntrc: "",
          combinacao_veicular: '02',
          veiculo_tracao: {
            placa: "",
            tara: 0,
            uf_licenciamento: "",
            tipo_rodado: "",
            tipo_carroceria: "",
          },
          veiculo_reboque: [],
          condutor: [],
          contratante: [],
        },
        produto_predominante: {
          tipo_carga: "",
          nome: "",
          ncm: "",
        },
        ciot: [],
        vale_pedagio: [],
        pagamento_frete: [],
        idCondutor: "",
        percurso: [],
      },
      spinGeneral: false,
      ufs: ufs,
      uniqueRoute: "",
      loadingToSend: false,
      tabs: [
        { value: "Dados do Transporte", text: "Dados do Transporte" },
        { value: "Informações Pagamento", text: "Informações Pagamento" },
        { value: "Outros", text: "Outros" },
      ],
      selectedLabel: "Dados do Transporte",
      exibitionOrigin: "",
      exibitionDestiny: "",
      selectedProduct: null,
      idProductFromSearch: "",
      createdNewProducts: null,
      toggleClearSelect: false,
      launchBill: false,
    }
  },
  methods: {
    ...mapMutations(["SET_DATA_SEARCH_FROM_MDFE"]),
    async storeLabelName(labelName) {
      this.selectedLabel = labelName;
    },

    adicionarCiot() {
      if (!this.ciotAtual.codigo_ciot) {
        return this.$toast.open({ message: "O código CIOT é obrigatório.", type: "info" });
      }
      this.dadosMdfe.ciot.push({ ...this.ciotAtual });
      this.ciotAtual = { codigo_ciot: "", cpf_responsavel: "" };
    },

    removerCiot(index) {
      this.dadosMdfe.ciot.splice(index, 1);
    },

    adicionarValePedagio() {
      if (!this.valePedagioAtual.comprovante || this.valePedagioAtual.valor <= 0) {
        return this.$toast.open({ message: "Comprovante e valor do pedágio são obrigatórios.", type: "info" });
      }
      this.dadosMdfe.vale_pedagio.push({ ...this.valePedagioAtual });
      this.valePedagioAtual = { cnpj_fornecedor: "", cpf_responsavel: "", comprovante: "", valor: 0, tipo: "1" };
      this.$refs.valorPedagio.valueInput = 0;
    },

    removerValePedagio(index) {
      this.dadosMdfe.vale_pedagio.splice(index, 1);
    },

    adicionarComponente() {
      if (this.componenteAtual.valor_componente <= 0) {
        return this.$toast.open({ message: "O valor do componente é obrigatório.", type: "info" });
      }
      this.pagamentoFrete.componentes_pagamento_frete.push({ ...this.componenteAtual });
      this.componenteAtual = { tipo_componente: "99", valor_componente: 0, descricao_componente: "" };
      this.$refs.valorComponente.valueInput = 0;
    },

    adicionarParcela() {
      if (!this.parcelaAtual.data_vencimento_parcela || this.parcelaAtual.valor_parcela <= 0) {
        return this.$toast.open({ message: "Data de vencimento e valor da parcela são obrigatórios.", type: "info" });
      }
      this.pagamentoFrete.informacoes_pagamento_prazo.push({ ...this.parcelaAtual });
      this.parcelaAtual = { data_vencimento_parcela: null, valor_parcela: 0 };
      this.$refs.valor_parcela.valueInput = 0;
      this.$refs.data_vencimento_parcela.valueInput = null;
    },

    removerParcela(index) {
      this.pagamentoFrete.informacoes_pagamento_prazo.splice(index, 1);
    },
    removerComponente(index) {
      this.pagamentoFrete.componentes_pagamento_frete.splice(index, 1);
    },


    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    handleModalCreateProduct(nameModal, idProduct) {
      this.idProductFromSearch = idProduct;
      this.openModals(nameModal);
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleCreatedNewProduct() {
      this.createdNewProducts = !this.createdNewProducts;
    },

    async selectProductSetDefaultValue(product) {
      if (product) {
        this.dadosMdfe.produto_predominante.ncm = product.ncm
        this.dadosMdfe.produto_predominante.nome = product.nome
      }
    },

    async updateOrSaveMdfe() {
      this.dadosMdfe.pagamento_frete = [this.pagamentoFrete];

      if (!this.dadosMdfe.percurso || this.dadosMdfe.percurso.length === 0) {
        this.dadosMdfe.percurso = []
      }

      this.dadosMdfe.carregamento[0] = this.carregamento
      this.dadosMdfe.descarregamento[0] = this.descarregamento
      const isValid = ValidadeMdfe(this.dadosMdfe);
      if (isValid && Object.keys(isValid).length) {
        this.handleFocus(isValid.keyError);
        return this.$toast.open({
          message: isValid.message,
          type: "info",
        });
      }

      this.dadosMdfe.peso_bruto = this.dadosMdfe.peso_bruto.toString()
      if (this.dadosMdfe.id === "") return this.saveMdfe();
      await this.updateMdfe();
    },

    async consultaMdfe(id) {
      try {
        const response = await ServiceMdfe.consultaMdfe(id)
        const blob = new Blob([response], { type: "application/pdf" });

        const pdfUrl = URL.createObjectURL(blob);

        window.open(pdfUrl, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    handleFocus(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].focus();
      }
      this.isInvalidInput = "isInvalidInput";
    },

    clearInvalidInput() {
      this.isInvalidInput = "";
    },

    insertRoute() {
      if (!this.uniqueRoute) {
        return this.$toast.open({
          message: "Selecione uma UF para adicionar.",
          type: "info",
        });
      }

      const selectedUF = this.ufs.find(
        (uf) => uf.value === this.uniqueRoute
      );

      if (selectedUF.value === this.dadosMdfe.uf_carregamento || selectedUF.value === this.dadosMdfe.uf_descarregamento) {
        return this.$toast.open({
          message: "A UF do percurso não pode ser igual a UF de carregamento ou descarregamento!",
          type: "info",
        })
      }

      if (this.dadosMdfe.percurso === null) {
        this.dadosMdfe.percurso = []
      }

      this.dadosMdfe.percurso.push(selectedUF.value);
      this.uniqueRoute = "";
    },

    insertKey() {
      if (!this.chaves) {
        return this.$toast.open({
          message: "Chave não pode ser vazia.",
          type: "info",
        });
      }
      this.descarregamento.documentos_fiscais.push({ chave: this.chaves });
      this.chaves = "";
    },

    insertRebock() {
      if (!this.veiculoReboque.placa) {
        return this.$toast.open({
          message: "Placa do reboque não pode ser vazia.",
          type: "info",
        });
      }

      const limparObjeto = (obj) => {
        return Object.entries(obj).reduce((acc, [key, value]) => {
          if (value && typeof value === 'object' && !Array.isArray(value)) {
            const cleanedSubObj = limparObjeto(value);
            if (Object.keys(cleanedSubObj).length > 0) acc[key] = cleanedSubObj;
          }
          else if (value !== "" && value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {});
      };

      const reboqueFiltrado = limparObjeto(this.veiculoReboque);
      this.dadosMdfe.rodoviario.veiculo_reboque.push(reboqueFiltrado);

      this.veiculoReboque = {
        placa: "", renavam: "", tara: 0, capacidade_kg: 0, uf_licenciamento: "", tipo_carroceria: "",
        proprietario: { cpf: "", cnpj: "", nome: "", razao_social: "", ie: "", rntrc: "", tipo_proprietario: "0", uf: "" }
      };
    },

    removeRebock(index) {
      this.dadosMdfe.rodoviario.veiculo_reboque.splice(index, 1);
    },

    insertContractant() {
      if (!this.contratanteUN.cpf && !this.contratanteUN.cnpj) {
        return this.$toast.open({
          message: "CPF ou CNPJ do contratante não pode ser vazio.",
          type: "info",
        });
      }

      const novoContratante = {};

      if (this.selectContractant === 1 && this.contratanteUN.cpf) {
        novoContratante.cpf = this.contratanteUN.cpf;
      } else if (this.selectContractant === 2 && this.contratanteUN.cnpj) {
        novoContratante.cnpj = this.contratanteUN.cnpj;
      }
      this.dadosMdfe.rodoviario.contratante.push(novoContratante);

      this.contratanteUN = { cpf: "", cnpj: "", tipo: "0" };
    },

    removeContractant(index) {
      this.dadosMdfe.rodoviario.contratante.splice(index, 1);
    },

    removeItem(index) {
      this.dadosMdfe.percurso.splice(index, 1);
    },

    removeKey(index) {
      this.descarregamento.documentos_fiscais.splice(index, 1);
    },

    async saveMdfe() {
      try {
        const result = await ServiceMdfe.saveMdfe(this.dadosMdfe);
        this.dadosMdfe.id = result;
        return this.$toast.open({
          message: "Manifesto Eletrônico salvo!",
          type: "success",
        });
      } catch (error) {
        this.showMdfeError(error, "Ocorreu um erro ao salvar a MDF-e");
      }
    },

    async updateMdfe() {
      if (Array.isArray(this.dadosMdfe.percurso) && this.dadosMdfe.percurso.length === 0) {
        this.dadosMdfe.percurso = null;
      }
      try {
        await ServiceMdfe.updateMdfe(this.dadosMdfe);

        return this.$toast.open({
          message: "Manifesto Eletrônico atualizado!",
          type: "success",
        });
      } catch (error) {
        this.showMdfeError(error, "Ocorreu um erro ao atualizar a MDF-e");
      }
    },

    async sendMdfe() {
      try {
        this.loadingToSend = true
        const data = await ServiceMdfe.sendMdfe(this.dadosMdfe.rodoviario.idVeiculo, this.dadosMdfe.id);

        const response = typeof data === "string" ? JSON.parse(data) : data;

        this.dadosMdfe.response = response
        this.dadosMdfe.status = response?.status || this.dadosMdfe.status;
        await this.consultaMdfe(this.dadosMdfe.id)

        return this.$toast.open({
          message: "Manifesto Eletrônico emitido!",
          type: "success",
        });
      } catch (error) {
        this.showMdfeError(error, "Ocorreu um erro ao emitir a MDF-e");
      } finally {
        this.loadingToSend = false
      }
    },

    async fetchCepLoading(cep) {
      try {
        this.spinGeneral = true;
        const formatedCep = String(cep || "").replace(/\D/g, "");
        if (formatedCep.length !== 8) {
          throw new Error("Informe um CEP válido com 8 dígitos");
        }
        const data = await ServiceMdfe.fetchingCep(formatedCep)
        const city = data?.localidade || data?.city;
        const state = data?.uf || data?.state;
        if (!city || !state || !data?.ibge) {
          throw new Error("CEP não encontrado ou sem código IBGE");
        }
        this.exibitionOrigin = `${city} - ${state}`;
        this.cep_carregamento = data.cep;
        this.dadosMdfe.uf_carregamento = state;
        this.carregamento.codigo_municipio = data.ibge;
        this.carregamento.nome_municipio = city;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Ocorreu um erro ao buscar o CEP",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    async fetchCepUnloading(cep) {
      try {
        this.spinGeneral = true;
        const formatedCep = String(cep || "").replace(/\D/g, "");
        if (formatedCep.length !== 8) {
          throw new Error("Informe um CEP válido com 8 dígitos");
        }
        const data = await ServiceMdfe.fetchingCep(formatedCep)
        const city = data?.localidade || data?.city;
        const state = data?.uf || data?.state;
        if (!city || !state || !data?.ibge) {
          throw new Error("CEP não encontrado ou sem código IBGE");
        }
        this.exibitionDestiny = `${city} - ${state}`;
        this.cep_descarregamento = data.cep;
        this.dadosMdfe.uf_descarregamento = state;
        this.descarregamento.codigo_municipio = data.ibge;
        this.descarregamento.nome_municipio = city;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Ocorreu um erro ao buscar o CEP",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    async getAllVehicle() {
      const result = await ServiceVehicle.fillCombobox();
      this.vehicle = result;
    },

    async getAllConductor() {
      const result = await ServiceConductor.fillCombobox();
      this.conductor = result;
    },
    showMdfeError(error, fallbackMessage) {
      const backendError =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data ||
        error?.message;
      const parsedError = handleErrorsMdfe(backendError);

      this.$toast.open({
        message: parsedError?.message || fallbackMessage,
        type: "info",
      });
    },
    clear() {
      this.dadosMdfe = {
        id: "",
        data_mdfe: moment().format("YYYY-MM-DD HH:mm"),
        ambiente: "",
        emitente: 2,
        tipoCarga: "",
        url_notificacao: "",
        response: "",
        status: "",
        unidade: "01",
        modalidade: 1,
        uf_carregamento: "",
        uf_descarregamento: "",
        valor_carga: 0,
        peso_bruto: 0,
        carregamento: [],
        descarregamento: [],
        percurso: [],
        informacoes_complementares: "",
        rodoviario: {
          rntrc: "",
          combinacao_veicular: "02",
          idVeiculo: "",
          veiculo_tracao: {
            placa: "",
            tara: 0,
            uf_licenciamento: "",
            tipo_rodado: "",
            tipo_carroceria: "",
          },
          veiculo_reboque: [],
          condutor: [],
          contratante: [],
        },
        produto_predominante: {
          tipo_carga: "",
          nome: "",
          ncm: "",
        },
        ciot: [],
        vale_pedagio: [],
        pagamento_frete: [],
        idCondutor: "",
      };
      this.cep_carregamento = "";
      this.cep_descarregamento = "";
      this.chaves = "";

      this.carregamento.nome_municipio = "";
      this.carregamento.codigo_municipio = "";
      this.descarregamento.nome_municipio = "";
      this.descarregamento.codigo_municipio = "";
      this.descarregamento.documentos_fiscais = [];
      if (this.$refs.refMotorista) this.$refs.refMotorista.valueItems = "";
      if (this.$refs.refVeiculos) this.$refs.refVeiculos.valueItems = "";
      if (this.$refs.valor) this.$refs.valor.valueInput = "";

      this.pagamentoFrete = {
        nome: "",
        cpf: "",
        valor_contrato: 0,
        forma_pagamento: 0,
        valor_adiantamento: 0,
        componentes_pagamento_frete: [],
        informacoes_bancarias: {
          tipo_informacao_bancaria: "0",
          numero_banco: "",
          numero_agencia: "",
          pix: ""
        },
        informacoes_pagamento_prazo: [],
      };
      this.dadosMdfe.pagamento_frete = [];
      this.SET_DATA_SEARCH_FROM_MDFE({});
    },

    maskToKg(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }

      return `KG ${parseFloat(valor).toLocaleString(locale, { minimumFractionDigits: 2 })}`;
    },

    handleGrossWeight(event) {
      this.dadosMdfe.peso_bruto = mascaraMoeda(event);
    },

    assignEdit() {
      this.carregamento.nome_municipio = this.dataSearchFromMdfe.carregamento[0].nome_municipio;
      this.carregamento.codigo_municipio = this.dataSearchFromMdfe.carregamento[0].codigo_municipio;
      this.descarregamento.nome_municipio = this.dataSearchFromMdfe.descarregamento[0].nome_municipio;
      this.descarregamento.codigo_municipio = this.dataSearchFromMdfe.descarregamento[0].codigo_municipio;
      this.chaves = "";
      this.dadosMdfe.idCondutor = this.dataSearchFromMdfe.idCondutor;
      this.dadosMdfe.idVeiculo = this.dataSearchFromMdfe.rodoviario.idVeiculo;
      this.$refs.refMotorista.valueItems = this.dataSearchFromMdfe.idCondutor;
      this.$refs.refVeiculos.valueItems = this.dataSearchFromMdfe.rodoviario.idVeiculo;
      this.$refs.valor.valueInput = this.dataSearchFromMdfe.valor_carga;
      this.dadosMdfe.valor_carga = this.dataSearchFromMdfe.valor_carga;
      this.dadosMdfe.informacoes_complementares = this.dataSearchFromMdfe.informacoes_complementares || "";
      this.dadosMdfe.ambiente = this.dataSearchFromMdfe.ambiente;
      this.descarregamento.documentos_fiscais = this.dataSearchFromMdfe.descarregamento[0].documentos_fiscais;

      if (typeof this.dataSearchFromMdfe.percurso === 'string') {
        this.dadosMdfe.percurso = [this.dataSearchFromMdfe.percurso];
      } else {
        this.dadosMdfe.percurso = this.dataSearchFromMdfe.percurso;
      }

      if (this.dataSearchFromMdfe.pagamento_frete && Object.keys(this.dataSearchFromMdfe.pagamento_frete).length > 0) {
        this.pagamentoFrete = { ...this.dataSearchFromMdfe.pagamento_frete[0] };

        if (this.$refs.valorContrato)
          this.$refs.valorContrato.valueInput = this.dataSearchFromMdfe.pagamento_frete[0].valor_contrato

        if (this.$refs.valorAdiantamento)
          this.$refs.valorAdiantamento.valueInput = this.dataSearchFromMdfe.pagamento_frete[0].valor_adiantamento
      }

      // this.dadosMdfe.transportador = this.dataSearchFromMdfe.transportador

      this.exibitionOrigin = `${this.carregamento.nome_municipio} - ${this.dataSearchFromMdfe.uf_carregamento}`
      this.exibitionDestiny = `${this.descarregamento.nome_municipio} - ${this.dataSearchFromMdfe.uf_descarregamento}`
    },

    async getConfig() {
      if (this.dadosMdfe.id === "") {
        const result = await ServiceSettings.findSettingsAtm();
        if (Object.keys(result).length) {
          this.dadosMdfe.ambiente = result.emissao_fiscal.ambiente;
        }
      }
    },

    checkInputLengthresponsavel() {
      if (this.valePedagioAtual.cpf_responsavel.length === 18)
        this.$forceUpdate();
    },
    checkInputLengthForCnpj() {
      if (this.valePedagioAtual.cnpj_fornecedor.length === 18)
        this.$forceUpdate();
    },
    checkInputLengthciot() {
      if (this.ciotAtual.cpf_responsavel.length === 18)
        this.$forceUpdate();
    },
    checkInputLengthContract() {
      if (this.contratanteUN.cpf.length === 18)
        this.$forceUpdate();
    },
    checkInputLengthReboque() {
      if (this.veiculoReboque.proprietario.cnpj.length === 18)
        this.$forceUpdate();
    },
    checkInputLengthfrete() {
      if (this.pagamentoFrete.cpf.length === 18)
        this.$forceUpdate();
    },
  },
  computed: {
    ...mapState(["dataSearchFromMdfe"]),
    maskCpfCnpjresponsavel() {
      if (!this.valePedagioAtual.cpf_responsavel) {
        return "";
      }

      if (this.valePedagioAtual.cpf_responsavel.length <= 14) {
        return "###.###.###-##";
      }

      if (this.valePedagioAtual.cpf_responsavel.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },
    maskCpfCnpjForCnpj() {
      if (!this.valePedagioAtual.cnpj_fornecedor) {
        return "";
      }

      if (this.valePedagioAtual.cnpj_fornecedor.length <= 14) {
        return "###.###.###-##";
      }

      if (this.valePedagioAtual.cnpj_fornecedor.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },
    maskCpfCnpjciot() {
      if (!this.ciotAtual.cpf_responsavel) {
        return "";
      }

      if (this.ciotAtual.cpf_responsavel.length <= 14) {
        return "###.###.###-##";
      }

      if (this.ciotAtual.cpf_responsavel.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },
    maskCpfCnpjfrete() {
      if (!this.pagamentoFrete.cpf) {
        return "";
      }

      if (this.pagamentoFrete.cpf.length <= 14) {
        return "###.###.###-##";
      }

      if (this.pagamentoFrete.cpf.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },
    maskCpfCnpjContractant() {
      if (!this.contratanteUN.cpf) {
        return "";
      }

      if (this.contratanteUN.cpf.length <= 14) {
        return "###.###.###-##";
      }

      if (this.contratanteUN.cpf.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },
    maskCpfCnpjReboque() {
      if (!this.veiculoReboque.proprietario.cnpj) {
        return "";
      }

      if (this.veiculoReboque.proprietario.cnpj.length <= 14) {
        return "###.###.###-##";
      }

      if (this.veiculoReboque.proprietario.cnpj.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.getAllConductor();
    this.getAllVehicle();
    if (this.dataSearchFromMdfe && Object.keys(this.dataSearchFromMdfe).length) {
      Object.assign(this.dadosMdfe, this.dataSearchFromMdfe);
      this.assignEdit();
    }
    this.getConfig();
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_MDFE({});
  },
}

export default mixinMdfe
